import { CalorieIcon, InIcon, OutIcon } from "../../assets";
import { formatNumberToLocaleString } from "../../utils/methods";
import EditableMacroIconItem from "../EditableMacroIconItem";
import MacroIconItem from "../MacroIconItem";
import styles from "./styles.module.scss";

type EditableMacroEquationProps = {
  eat: string;
  burn: number;
  onChangeEat: (eat: string) => void;
};

const EditableMacroEquation: React.FC<EditableMacroEquationProps> = ({
  eat,
  burn,
  onChangeEat,
}) => {
  const deficit = burn - +eat;

  return (
    <div className={styles.wrapper}>
      <EditableMacroIconItem
        icon={<InIcon style={{ fill: "rgba(97, 42, 255, 1)" }} />}
        iconBackgroundCOlor="rgba(97, 42, 255, 0.2)"
        title="Eat"
        value={eat}
        onChangeValue={onChangeEat}
      />
      <span>-</span>
      <MacroIconItem
        gap={11}
        icon={<OutIcon style={{ fill: "rgba(255, 168, 0, 1)" }} />}
        iconBackgroundCOlor="rgba(255, 168, 0, 0.2)"
        title="Burn"
        value={`${formatNumberToLocaleString(burn)} cal`}
      />
      <span>=</span>

      <MacroIconItem
        gap={11}
        icon={<CalorieIcon style={{ fill: "rgba(54, 217, 14,1)" }} />}
        iconBackgroundCOlor="rgba(54, 217, 14, 0.2)"
        title="Deficit"
        value={`${formatNumberToLocaleString(deficit)} cal`}
      />
    </div>
  );
};

export default EditableMacroEquation;
